/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * ScheduleManagementIcon - Auto-generated from icon.js
 */
export const ScheduleManagementIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g id="icon / sidemenu">
			<path id="Icon" d="M16.6393 16.5427L18.7025 15.8447C19.0892 15.7139 19.1022 15.1833 18.7222 15.0346L13.607 13.032C13.2512 12.8927 12.8952 13.2324 13.0287 13.584L14.9772 18.7181C15.1196 19.0933 15.6616 19.0942 15.8052 18.7194L16.6393 16.5427Z" stroke="#333333" stroke-linecap="round" stroke-linejoin="round" />
			<path id="Vector" d="M17.5 10.834V5.00065C17.5 4.08018 16.7538 3.33398 15.8333 3.33398H4.16667C3.24619 3.33398 2.5 4.08018 2.5 5.00065V16.6673C2.5 17.5878 3.24619 18.334 4.16667 18.334H10" stroke="#333333" stroke-linecap="round" stroke-linejoin="round" />
			<path id="Vector_2" d="M13.334 1.66602V4.99935" stroke="#333333" stroke-linecap="round" stroke-linejoin="round" />
			<path id="Vector_3" d="M6.66602 1.66602V4.99935" stroke="#333333" stroke-linecap="round" stroke-linejoin="round" />
			<path id="Vector_4" d="M2.5 8.33398H17.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round" />
		</g>
	</svg>
);

export default ScheduleManagementIcon;
